import { IReportComponentBlueprint } from '../services/decoders/blueprintDecoder'

export const getMinutesSpentString = (deltaTime: number) => {
  if (deltaTime <= 0) {
    return
  }
  const minutesSpent = Math.round(deltaTime / 60000)
  const secondsSpent = minutesSpent % 60
  return `${minutesSpent > 0 ? `${minutesSpent}`.padStart(2, '0') : '00'}:${secondsSpent > 0 ? `${secondsSpent}`.padStart(2, '0') : '00'
    }`
}

export const findNode = (
  nodeId: string,
  structure: IReportComponentBlueprint[],
): IReportComponentBlueprint | undefined => {
  const node = structure.find(item => item.id === nodeId)
  if (node) return node
  for (let i = 0; i < structure.length; i++) {
    const item = structure[i]
    if (item.children) {
      const node = findNode(nodeId, item.children)
      if (node) return node
    }
  }
}

export const findParentNode = (
  nodeId: string,
  structure: IReportComponentBlueprint[],
): IReportComponentBlueprint | undefined => {
  for (let i = 0; i < structure.length; i++) {
    const node = structure[i]
    if (node.children) {
      for (let j = 0; j < node.children.length; j++) {
        const child = node.children[j]
        if (child.id === nodeId) return node
        if (node.children) {
          const found = findParentNode(nodeId, node.children)
          if (found) return found
        }
      }
    }
  }
}

export const capitalizeFirstLetter = (str: string): string => {
  return `${str?.charAt(0)?.toUpperCase()}${str?.slice(1)}`
}
